// Display the build information
if(typeof(window.vfdp) === 'undefined') {
  window.vfdp = {};
}

window.vfdp.ui = {
  'branch': "release/rel-24.21",
  'commit': {
    'short': "ed5849ed15",
    'hash': "ed5849ed1525fe838f71f7f88b77fa1cb92ca91b"
  },
  'build': "30319"
};

console.info('UI version:',window.vfdp.ui);
